var BaseView = require('./baseView');

/**
 * This is now only for the top level model
 */

module.exports = BaseView.extend({

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/notePropertyViews/shapeProperties/redaction/noteLevelView.js
 ** module id = 604
 ** module chunks = 0
 **/